import React from 'react'
import _ from 'lodash'
import * as StyledComponent from '../styles'

const MultiLineTitle = (props, context) => {
  const lines = _.map((props.title||'').split('|'), (line, index) => {
    return <div key={`ml-${index}${line ? `-${line}` : ''}`}>{_.trim(line)}</div>
  })

  return <StyledComponent.MultiLineTitle>{lines}</StyledComponent.MultiLineTitle>
}
export default MultiLineTitle



// WEBPACK FOOTER //
// ./src/components/MultiLineTitle.js